/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDTO } from './userDTO';


export interface UserProfileDTO {
    age?: number;
    birthDate?: string;
    clientSideMetadata?: string;
    height?: number;
    id?: string;
    nationality?: string;
    photo?: string;
    role?: string;
    sport?: string;
    subscriptionLevel?: number;
    trainer?: boolean;
    user?: UserDTO;
    weight?: number;
}

